import HomeIcon from '@mui/icons-material/Home';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import Face6Icon from '@mui/icons-material/Face6';
 
 const listmneubar = [
    {
        name: "Home",
        icon: <HomeIcon  className="icon-menu" />,
        link: "/dashboard"
    },
    {
        name:"Billing",
        icon: <RequestQuoteIcon className="icon-menu" />,
        link:"bills"

    },
    {
        name:"Menu",
        icon: <ListAltIcon className="icon-menu" />,
        link:"MenuItems"

    },
    {
        name:"Time",
        icon: <AccessAlarmIcon className="icon-menu" />,
        link:"valueTimes"

    },
    {
        name:"Profile",
        icon: <Face6Icon className="icon-menu" />,
        link:"profile"

    },
   
    
]

export default listmneubar